<template>
	<div class="Card Card--small">
	    <div :class="containerClass ?? 'Card__content'">
	    	<template v-for="(item, index) in options" :key="item.label">
	    		<div class="Radio" v-if="item.label">
	                <input class="Radio__input" 
	                	type="radio" 
                		:id="`type_radio_${dtPost.id}_${colIndex}_${ index }`" 
                		:name="columnName" 
                		:value="item.term" 
                		:data-label="item.label" 
                		:checked="item.current"
                		v-model="filterOption"
                		@change="filterChanged"
                		>
	                <label class="Radio__label" 
	                	:for="`type_radio_${dtPost.id}_${colIndex}_${ index }`">{{ item.label }}</label>
	            </div>
	    	</template>
	    <!-- {% if options %}
	        {% for item in options %}

	            {% if dt_post is empty %}
	                {% set dt_post = chart_data.post %}
	            {% endif %}
	            {% if item.label %}
	            <div class="Radio">
	                <input class="Radio__input" type="radio" id="type_radio_{{ dt_post.id }}_{{ filter_i }}_{{ loop.index }}" name="{{ db_filter.column_name }}" value="{{ item.term }}" data-label="{{ item.label }}" {{ item.current ? 'checked' }}>
	                <label class="Radio__label" for="type_radio_{{ dt_post.id }}_{{ filter_i }}_{{ loop.index }}">{{ item.label }}</label>
	            </div>
	            {% endif %}
	        {% endfor %}
	    {% else %}
	        <span class="empty-auto-filters-span">{{ theme_lo.filters_dropdown_empty_message ?? 'Filter options will be displayed once the database contains data.' }}</span>
	    {% endif %} -->
	    </div>
	    <div class="Card__actions Card__actions--trailing">
	        <button class="Btn Btn--small Btn--primary" type="submit">{{ themeLo.save ?? 'Save' }}</button>
	        <button 
	        	class="Btn-text Btn--small" 
	        	:disabled="filterActive ? null : 'disabled'"
	        	@click="resetFilter"
	        	>{{ themeLo.reset ?? 'Reset' }}</button>
	    </div>
	    <!-- <pre>
	    	{{ options }}
	    </pre> -->
	</div>
</template>

<script>
export default {
	props: {
		columnName: String,
		options: Array,
		themeLo: Object,
		containerClass: String,
		dtPost: Object,
		colIndex: Number,
		filterActive: Boolean,
		open: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			filterOption: ''
		}
	},
	emits: ['change', 'reset'],
	methods: {
		filterChanged() {
			this.$emit('change', {filterValue: this.filterOption})
		},
		resetFilter() {
			this.filterOption = ''
			this.$emit('reset', {filterValue: this.filterOption})
		}
	},
	created() {
		this.emitter.on('reset-all-ev', (evt) => {
			this.filterOption = ''
	    })
	}
}
</script>